exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "svg[data-v-737775c8]{flex-shrink:0;fill:var(--navbar-icon-color);transition:fill 0.3s ease-in-out}\n", ""]);
